<div class="main-container">
  <div class="grid-container" id="368report-grid-container" style="height: calc(100vh - 124px);">
      <div class="top-toolbar">
          <div class="toolbar-actions">
            @if (taxyearLoaded) {
<ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'" [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYearItem" (onSelect)="onTaxYearChanged($event)">
  @for (item of taxYearItems; track item.value) {
    <ap-dropdown-list-item #dropdownListItem [item]="item" [ariaLabel]="setTaxYearAriaLabel(item)" (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
  }
</ap-dropdown>
}
            <gtw-df-me-dropdown class="top-filter-select me-dropdown-label" [customActionCode]="32136" (selectedMes)="selectedMeChanged($event)">
            </gtw-df-me-dropdown>
            <ap-button [compact]="true" [btnType]="'primary'" [label]="'Filter'" (onClick)="loadReport()"></ap-button>
            <span class="toolbar-export" (click)="exportToExcel()">
              <span class="Appkit4-icon icon-save-outline"></span>
              <span>Export to Excel</span>
            </span>
          </div>
      </div>

      <div class="dst-mat-grid-layout">
        @if (loading) {
          <div class="dst-mat-grid-loading">
            <mat-spinner [diameter]="40"></mat-spinner>
          </div>
        }
        <div class="dst-mat-grid">
          <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort #matSort="matSort"
                 (matSortChange)="onMatSortChange()" class="dst-mat-table">

            <ng-container matColumnDef="STATEMENTID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[0])">{{ cols[0].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[0])">
                <a href="javascript:void(0);" (click)="showViewUpdateStatement(rowData)"><span>{{ rowData.STATEMENTID }}</span></a>
              </td>
            </ng-container>

            <ng-container matColumnDef="PROJECT_NAME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[1])">{{ cols[1].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[1])">
                <span>{{ rowData.PROJECT_NAME }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PRIMARYLEID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[2])">{{ cols[2].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[2])">
                <span>{{ rowData.PRIMARYLEID }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PRIMARYENTITY">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[3])">{{ cols[3].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[3])">
                <span>{{ rowData.PRIMARYENTITY }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PRIMARYBUSINESS">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[4])">{{ cols[4].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[4])">
                <span>{{ rowData.PRIMARYBUSINESS }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="FILLING_GROUP">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[5])">{{ cols[5].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[5])">
                <span>{{ rowData.FILLING_GROUP }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="SECONDARYLEID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[6])">{{ cols[6].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[6])">
                <span>{{ rowData.SECONDARYLEID }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="SECONDARYENTITY">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[7])">{{ cols[7].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[7])">
                <span>{{ rowData.SECONDARYENTITY }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="SIGNIFICANT_HOLDER">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[8])">{{ cols[8].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[8])">
                <span>{{ rowData.SIGNIFICANT_HOLDER }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="SIGNIFICANTHOLDER_NAME">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[9])">{{ cols[9].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[9])">
                <span>{{ rowData.SIGNIFICANTHOLDER_NAME }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="DATE_OF_REORGANIZATION">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[10])">{{ cols[10].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[10])">
                <span>{{ rowData.DATE_OF_REORGANIZATION | date: 'yyyy-MM-dd' }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="REORGANIZATIONCODESECTION">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[11])">{{ cols[11].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[11])">
                <span>{{ rowData.REORGANIZATIONCODESECTION }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="IMPORTATIONPROPERTYDESC">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[12])">{{ cols[12].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[12])">
                <span>{{ rowData.IMPORTATIONPROPERTYDESC }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="LOSSDUPLICATIONPROPERTDESC">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[13])">{{ cols[13].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[13])">
                <span>{{ rowData.LOSSDUPLICATIONPROPERTDESC }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="GAINLOSSPROPERTYDESC">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[14])">{{ cols[14].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[14])">
                <span>{{ rowData.GAINLOSSPROPERTYDESC }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="DESCRIPTION">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[15])">{{ cols[15].header }}</th>
              <td mat-cell *matCellDef="let rowData" class="text-pre-wrap" [ngStyle]="getColStyle(cols[15])">
                <span gtwLineSplitter [inputString]="rowData.DESCRIPTION" [sepearator]="'||'">
                  {{ rowData.DESCRIPTION }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="BASIS_AMOUNT">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[16])">{{ cols[16].header }}</th>
              <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[16])">
                <span gtwLineSplitter [inputString]="rowData.BASIS_AMOUNT" [sepearator]="'||'" [formatter]="'decimal'">
                  {{ rowData.BASIS_AMOUNT }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="BASIS_CURRENCY">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[17])">{{ cols[17].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[17])">
                <span>{{ rowData.BASIS_CURRENCY }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="BASISTYPE">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[18])">{{ cols[18].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[18])">
                <span>{{ rowData.BASISTYPE }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="FMV_AMOUNT">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[19])">{{ cols[19].header }}</th>
              <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[19])">
                <span gtwLineSplitter [inputString]="rowData.FMV_AMOUNT" [sepearator]="'||'" [formatter]="'decimal'">
                  {{ rowData.FMV_AMOUNT }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="FMV_CURRENCY">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[20])">{{ cols[20].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[20])">
                <span>{{ rowData.FMV_CURRENCY }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="STOCKSSECURITYPROPERTYDESC">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[21])">{{ cols[21].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[21])">
                <span>{{ rowData.STOCKSSECURITYPROPERTYDESC }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="STOCKSSECURITYNOTDESC">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[22])">{{ cols[22].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[22])">
                <span gtwLineSplitter [inputString]="rowData.STOCKSSECURITYNOTDESC" [sepearator]="'||'">
                  {{ rowData.STOCKSSECURITYNOTDESC }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="BASIS_AMOUNT1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[23])">{{ cols[23].header }}</th>
              <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[23])">
                <span gtwLineSplitter [inputString]="rowData.BASIS_AMOUNT1" [sepearator]="'||'" [formatter]="'decimal'">
                  {{ rowData.BASIS_AMOUNT1 }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="BASIS_CURRENCY1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[24])">{{ cols[24].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[24])">
                <span>{{ rowData.BASIS_CURRENCY1 }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="BASISTYPE1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[25])">{{ cols[25].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[25])">
                <span>{{ rowData.BASISTYPE1 }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="FMV_AMOUNT1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[26])">{{ cols[26].header }}</th>
              <td mat-cell *matCellDef="let rowData" style="text-align: end;" [ngStyle]="getColStyle(cols[26])">
                <span gtwLineSplitter [inputString]="rowData.FMV_AMOUNT1" [sepearator]="'||'" [formatter]="'decimal'">
                  {{ rowData.FMV_AMOUNT1 }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="FMV_CURRENCY1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[27])">{{ cols[27].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[27])">
                <span>{{ rowData.FMV_CURRENCY1 }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="PLRCONTROLNUMBER">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[28])">{{ cols[28].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[28])">
                <span>{{ rowData.PLRCONTROLNUMBER }}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="ADOPTEDDATE_VALUE">
              <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(cols[29])">{{ cols[29].header }}</th>
              <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(cols[29])">
                <span>{{ rowData.ADOPTEDDATE_VALUE }}</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 45px;"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 70px;"></tr>
          </table>
        </div>
      </div>
  </div>
</div>

@if (showModalViewer) {
<dst-disc-modal-viewer [rowObject]="activeRow" (afterModalClosed)="afterModalClosed()">
</dst-disc-modal-viewer>
}
